import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useMFAStore } from '../../stores/mfaStore';
import { Button } from '../common/Button';

export function EnrollMFA() {
  const {
    error,
    qrCode,
    code,
    totpFactor,
    setCode,
    startEnrollment,
    verifyEnrollment,
    disableMFA,
    listFactors,
  } = useMFAStore();
  const { t } = useTranslation('auth');
  const [showDisableForm, setShowDisableForm] = useState(false);

  useEffect(() => {
    listFactors();
  }, [listFactors]);

  const handleStart = async () => {
    await startEnrollment();
  };

  const handleVerify = async () => {
    await verifyEnrollment();
  };

  const handleDisable = async () => {
    await disableMFA();
    setShowDisableForm(false);
  };

  return (
    <div className="mfa-enrollment space-y-4">
      {error && <div className="text-red-500">{error}</div>}

      {totpFactor ? (
        <>
          {!showDisableForm ? (
            <>
              <label className="block text-secondary font-ambit text-base font-bold mb-4">
                {t('improveProfileStep.security.twoFA')}
              </label>
              <Button
                onClick={() => setShowDisableForm(true)}
                type="button"
                variant="primary"
                className="w-full rounded-full p-10"
              >
                {t('disableAuthCTA', { ns: 'auth' })}
              </Button>
              <p className="text-secondary font-ambit text-sm">
                {t('downloadGoogleAuth', { ns: 'auth' })}
              </p>
            </>
          ) : (
            <>
              <label className="block text-secondary font-ambit text-base font-bold mb-4">
                {t('improveProfileStep.security.twoFA')}
              </label>
              <p>{t('authCTADesableHint')}</p>
              <input
                type="text"
                value={code}
                onChange={e => setCode(e.target.value)}
                placeholder={t('codePlaceholder')}
                className="w-full round-full bg-[#E1E9F0] rounded px-2 py-3 text-sm"
              />

              <Button
                onClick={handleDisable}
                type="button"
                variant="primary"
                className="w-full rounded-full p-10"
                disabled={code.length !== 6}
              >
                {t('confirmDisable')}
              </Button>
            </>
          )}
        </>
      ) : qrCode ? (
        <>
          <label className="block text-secondary font-ambit text-base font-bold mb-4">
            {t('improveProfileStep.security.twoFA')}
          </label>
          <p>{t('authCTAScan')}</p>
          <img src={qrCode} alt="QR Code" className="w-40 h-40" />
          <p>{t('authCTAVerify')}</p>
          <input
            type="text"
            value={code}
            onChange={e => setCode(e.target.value)}
            placeholder={t('codePlaceholder')}
            className="w-full bg-[#E1E9F0] rounded px-2 py-3 text-sm"
          />

          <Button
            onClick={handleVerify}
            type="button"
            variant="primary"
            className="w-full rounded-full p-2 text-xs"
            disabled={code.length !== 6}
          >
            {t('enableAuthCTA')}
          </Button>
        </>
      ) : (
        <>
          <label className="block text-secondary font-ambit text-base font-bold mb-4">
            {t('improveProfileStep.security.twoFA')}
          </label>
          <Button
            onClick={handleStart}
            type="button"
            variant="primary"
            className="w-full rounded-full p-2 text-xs"
          >
            {t('enableAuthCTA')}
          </Button>
          <p className="text-secondary font-ambit text-sm">
            {t('downloadGoogleAuth', { ns: 'auth' })}
          </p>
        </>
      )}
    </div>
  );
}
